import { getUnitLabel } from './unitLabel'

export interface VolumeTotal {
    unit: string
    ordered: number
    distributed: number
}

interface VolumeOverrides {
    /** Незбережені зміни комірок за uuid завдання (редагування) */
    pendingChanges?: Record<string, Record<string, any>>
    /** Локальний список завдань виконавця (додані/видалені без перезавантаження) */
    assignmentsByExecutor?: Record<string, any[]>
}

const toNumber = (value: unknown): number => {
    const parsed = parseFloat(String(value ?? 0))
    return Number.isNaN(parsed) ? 0 : parsed
}

/** Маса одного завдання з урахуванням незбереженої зміни */
const assignmentWeight = (assignment: any, pendingChanges?: Record<string, Record<string, any>>): number => {
    const override = pendingChanges?.[assignment?.uuid]?.['totalWeightTonnes']
    return toNumber(override !== undefined ? override : assignment?.totalWeightTonnes)
}

/** Розподілена маса одного виконавця */
export const executorDistributed = (
    assignments: any[] | undefined,
    pendingChanges?: Record<string, Record<string, any>>
): number => (assignments ?? []).reduce((sum, assignment) => sum + assignmentWeight(assignment, pendingChanges), 0)

/**
 * «Замовлено» і «розподілено» за підписом одиниці виміру потреб (`getUnitLabel`): `t`, `т`
 * і порожня одиниця дають одну групу «т». Поле `unit` результату — уже підпис.
 * Порядок — за першою появою одиниці серед потреб.
 */
export const summarizeVolumes = (vehicleNeeds: any[] | undefined, overrides: VolumeOverrides = {}): VolumeTotal[] => {
    const totals = new Map<string, VolumeTotal>()
    ;(vehicleNeeds ?? []).forEach((need: any) => {
        const unit = getUnitLabel(need?.unit)
        const total = totals.get(unit) ?? { unit, ordered: 0, distributed: 0 }
        total.ordered += toNumber(need?.volume)
        ;(need?.executors ?? []).forEach((executor: any) => {
            const assignments = overrides.assignmentsByExecutor?.[executor?.uuid] ?? executor?.assignments ?? []
            total.distributed += executorDistributed(assignments, overrides.pendingChanges)
        })
        totals.set(unit, total)
    })
    return Array.from(totals.values())
}

/** Обсяг у форматі з трьома знаками, як у бекенда */
export const formatVolume = (value: number): string => value.toFixed(3)
